import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import {
  delay, reduce, find, map,
  keyBy, each, filter,
  uniq, omit,
} from 'lodash';
import { withRouter, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import { Modal, NavItem } from 'react-bootstrap';

import ProgramDropdown from '../../components/program-dropdown';
import NumberDisplay from '../../../../components/number-display';
import { fetchClientInitiatives, nominationToggleProductMapping } from '../../NominationActions';
import { getPrograms } from '../../NominationReducer';
import {
  resetSelectedAccounts, resetAccounts, fetchAccounts, resetClientTrackings,
  selectAccount, unselectAccount, toogleAllAccounts, editAccount, editAccountEditContact,
  editAccountUpdateContact, fetchClientTrackings, submitSample,
  resetSavedParams, addSavedParams,
  fetchUnlinkedContacts,
  removeSavedParams,
  massFetchOpportunityContacts,
} from '../../CEActions';
import { getAccountLoading, getAccountLoaded, getAccountErrors, getAccountHasErrors,
  getSelectedAccounts, getAccounts, getEditingAccount,
  getMasterCheckboxStatus, getEditingAccountEditingContact, getSubmitParams,
  getTotalSaved, getSavedParamsLoading, getSavedParamsLoaded,
  getUnlinkedContactLoaded, getUnlinkedContactLoading, getUnlinkedContacts,
} from '../../CEReducer';
import { getIndexedProducts, getTVProductDictionary } from '../../../Setup/SetupReducer';
import { fetchAllProducts } from '../../../Setup/SetupActions';
import ProgressBar from '../../../../components/progress-bar';
import styles from './styles.css';
import SearchForm from '../../../../components/search-form';
import NominationNav from '../../components/nav';
import UnlinkedContactTable from '../../components/unlinked-contact-table';
import { getViewableDimensions } from '../../../App/AppReducer';
import EditModal from '../../components/edit-modal/ce-edit-modal';
import EditContactModal from '../../components/edit-contact-modal';
import requiredSetupMappings from '../../../../components/required-setup-mappings';
import RequiredTVProductMappingSetup from '../../components/ensure-tv-product-mapping';

import Counter from '../../../../components/counter';
import WarningModal from '../../components/warning-modal';
import Spinner from '../../../../components/spinner';
import AlertIcon from '../../../../components/alert-icon';
import DispositionModal from '../../components/ce-disposition-modal';
import AccountTable from '../../components/account-table';
import CEStats from '../../components/ce-stats';

const SUBMIT_STATUS = {
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  FAIL: 'fail',
};
const TABLE_NAME = 'nominations-customer-experience-table';
const SAVED_TABLE_NAME = 'nominations-customer-experience-saved-table';
const UNLINKED_CONTACT_TABLE_NAME = 'nominations-customer-experience-unlinked-contact-table';

export default function createClass(programType = 'Customer Experience') {
  class CustomerExperience extends Component {
    constructor(props) {
      super(props);
      this.state = {
        disabled: false,
        selectedProgramId: props.programId,
        editedAccounts: [],
        editedProgram: null,
        showWarning: false,
        submitStatus: null,
        submitResults: null,
        submitErrors: null,
        editModalTab: 1,
        showDispositions: false,
        selectedAccountDispositions: null,
        countSelected: 0,
        tvProductMappings: {},
      };
      this.hanldeReset = this.hanldeReset.bind(this);
      this.handleFormChange = this.handleFormChange.bind(this);
      this.handleContactInfoChange = this.handleContactInfoChange.bind(this);
      this.handleProgramChange = this.handleProgramChange.bind(this);
      this.handleConfirmWarning = this.handleConfirmWarning.bind(this);
      this.hanldeSubmit = this.hanldeSubmit.bind(this);
      this.hanldeToggleAll = this.hanldeToggleAll.bind(this);
      this.handleToggleProductMapping = this.handleToggleProductMapping.bind(this);
      this.showEditModal = this.showEditModal.bind(this);
      this.showDispositionsDetail = this.showDispositionsDetail.bind(this);
      this.hideDispositionsDetail = this.hideDispositionsDetail.bind(this);
      this.handleRequestSelectAccount = this.handleRequestSelectAccount.bind(this);
      this.handleRequestUnselectAccount = this.handleRequestUnselectAccount.bind(this);
      this.hanldeRequestSave = this.hanldeRequestSave.bind(this);
      this.handleOnUpdateAccount = this.handleOnUpdateAccount.bind(this);
      this.hanldeRequestUnsave = this.hanldeRequestUnsave.bind(this);
    }

    componentDidMount() {
      this.props.dispatch(resetSelectedAccounts());
      this.props.dispatch(resetAccounts());
      this.props.dispatch(fetchAllProducts())
        .then(
          () => {
            this.props.dispatch(resetAccounts()).then(() => {
              const program = this.getCurrentProgram();
              if (program) {
                this.initTVProductMappings();
                this.props.dispatch(fetchUnlinkedContacts(program.client_id, program.program_id));
                this.props.dispatch(fetchClientInitiatives(program.client_id, program.program_id));
              }
            });
          },
          () => {
            console.log('ERROR FETCHING PRODUCTS');
          },
        );
      this.mounted = true;
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    getCurrentProgram() {
      const { selectedProgramId } = this.state;
      const { programs } = this.props;
      const selectedPrograms = programs[programType];
      let selectedProgram = null;
      if (selectedProgramId) {
        selectedProgram = find(selectedPrograms, { program_id: selectedProgramId });
      }
      return selectedProgram;
    }

    initTVProductMappings() {
      const { tvProductDictionary, programId } = this.props;
      const tvProductMappings = reduce(tvProductDictionary, (items, mappings, tsProductId) => {
        const validMappings = filter(mappings, { program_type: programType, program_id: programId });
        items[tsProductId] = [];
        each(validMappings, (m) => {
          items[tsProductId].push(m.id);
        });
        return items;
      }, {});
      this.setState({ tvProductMappings });
    }
    loadTrackings(loadSavedParams = false) {
      const { accounts } = this.props;
      const program = this.getCurrentProgram();
      if (program && program.client_id) {
        const accountIds = map(accounts, 'account_id'); // fake opportunity ID by using account id
        this.props.dispatch(fetchClientTrackings(program.client_id, program.program_id, accountIds, loadSavedParams));
      }
      this.props.dispatch(resetClientTrackings());
      if (loadSavedParams) {
        this.props.dispatch(resetSavedParams());
      }
    }

    hanldeReset() {
      this.props.dispatch(resetSelectedAccounts());
      this.props.dispatch(resetAccounts());
    }

    handleOnUpdateAccount() {
      this.setState({ countSelected: this.state.countSelected + 1 });
    }

    hanldeRequestSave() {
      const program = this.getCurrentProgram();
      if (program) {
        const { selectedAccounts } = this.props;
        const clientId = program.client_id;
        const selectedProgramId = program.program_id;
        const attrs = ['accountContacts', 'contacts', 'indexedContacts', 'owner'];
        const accounts = reduce(selectedAccounts, (items, account) => {
          items.push(omit(account, attrs));
          return items;
        }, []);
        return this.props.dispatch(addSavedParams(clientId, selectedProgramId, accounts));
      }
      return Promise.reject(new Error('Missing program'));
    }

    hanldeRequestUnsave() {
      const program = this.getCurrentProgram();
      if (program) {
        const { submitParams } = this.props;
        const clientId = program.client_id;
        const selectedProgramId = program.program_id;

        const stats = submitParams.savedStats;
        const selected = map(stats.selected || [], 'account_id');
        return this.props.dispatch(removeSavedParams(clientId, selectedProgramId, selected));
      }
      return Promise.reject(new Error('Missing program'));
    }


    handleFormChange(criteria) {
      if (this.mounted) {
        this.props.dispatch(resetSelectedAccounts()).then(() => {
          this.props.dispatch(fetchAccounts(criteria)).then((results) => {
            this.loadTrackings(true);
            const { opportunities, total } = results;
            const returnResults = opportunities.length;
            if (total && returnResults < total) {
              const el = (
                <div>
                  Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                  For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                </div>
              );
              this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
            }
          });
        });
      }
    }

    handleContactInfoChange(contact) {
      this.props.dispatch(editAccountUpdateContact(contact));
    }

    handleRequestSelectAccount(account) {
      if (account.contactStatus === 'loaded') {
        return this.props.dispatch(selectAccount(account, this.state.tvProductMappings));
      }
      if (!account.contactStatus) {
        return new Promise((resolve, reject) => {
          this.props.dispatch(massFetchOpportunityContacts(account.opportunityIds))
            .then(
              () => {
                this.props.dispatch(selectAccount(account, this.state.tvProductMappings))
                  .then(
                    (r) => {
                      resolve(r);
                    },
                    (e) => {
                      reject(e);
                    },
                  );
              },
              (error) => {
                reject(error);
              },
            );
        });
      }
      return Promise.reject('loading');
    }

    handleRequestUnselectAccount(account) {
      return this.props.dispatch(unselectAccount(account));
    }
    handleProgramChange(program) {
      const { selectedProgramId, disabled } = this.state;
      const { selectedAccounts } = this.props;
      if (disabled) {
        return;
      }
      if (program.program_id !== selectedProgramId) {
        const currentProgram = this.getCurrentProgram();
        const initiatives = currentProgram.initiatives || {};
        const buyerTypes = keyBy(initiatives.buyerTypes, 'id');
        const buyerRoles = keyBy(initiatives.buyerRoles, 'id');
        const buyerTags = keyBy(initiatives.tags, 'id');

        const editedAccounts = reduce(selectedAccounts, (accounts, account) => {
          const editedContacts = reduce(account.selected_contacts, (contacts, contact) => {
            const buyerRole = buyerRoles[contact.buyer_role] ? buyerRoles[contact.buyer_role].name : null;
            const buyerType = buyerTypes[contact.buyer_type] ? buyerTypes[contact.buyer_type].name : null;
            const tags = reduce(contact.tags, (t, tag) => {
              if (buyerTags[tag]) {
                t.push(buyerTags[tag].name);
              }
              return t;
            }, []);
            const edited = buyerRole !== null || buyerType !== null || tags.length > 0;
            if (edited) {
              contacts.push({
                ...contact, buyer_role: buyerRole, buyer_type: buyerType, tags,
              });
            }
            return contacts;
          }, []);
          if (editedContacts.length > 0) {
            accounts.push({ ...account, selected_contacts: editedContacts });
          }
          // todo: check products
          return accounts;
        }, []);

        if (editedAccounts.length > 0) {
          this.setState({ editedAccounts, editedProgram: program, showWarning: true });
        } else {
          this.handleConfirmWarning(program);
        }
      }
    }

    handleConfirmWarning(program) {
      this.setState({
        editedAccounts: [],
        editedProgram: null,
        showWarning: false,
        selectedProgramId: program.program_id,
      });
      this.props.dispatch(fetchClientInitiatives(program.client_id, program.program_id))
        .then(() => {
          this.loadTrackings();
        });
    }

    hanldeSubmit(isSaved = false) {
      const { submitParams } = this.props;
      const program = this.getCurrentProgram();
      if (program) {
        const tvProducts = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];
        const indexedTVProducts = keyBy(tvProducts, 'id');

        const clientId = program.client_id;
        const selectedProgramId = program.program_id;
        const params = {
          opportunities: submitParams[isSaved ? 'savedParams' : 'params'].map((submitParam) => {
            let tvProductIds = [];
            const productNames = [];
            if (submitParam.selected_product_ids) {
              tvProductIds = submitParam.selected_product_ids;
              each(tvProductIds, (id) => {
                if (indexedTVProducts[id]) {
                  productNames.push(indexedTVProducts[id].name);
                }
              });
            }
            const productName = productNames.length > 0 ? productNames.join(', ') : null;

            return {
              ...submitParam,
              tv__productIds: tvProductIds,
              product: productName,
            };
          }),
        };

        this.setState({
          submitStatus: SUBMIT_STATUS.SUBMITTING, disabled: true, submitResults: null, submitErrors: null,
        });
        this.props.dispatch(submitSample(clientId, selectedProgramId, params))
          .then(
            (results) => {
              this.setState({ submitStatus: SUBMIT_STATUS.SUCCESS, disabled: false, submitResults: results });
              this.loadTrackings(true);
              this.props.dispatch(resetSelectedAccounts());
            },
            (errors) => {
              this.setState({ submitStatus: SUBMIT_STATUS.FAIL, disabled: false, submitErrors: errors.data || errors });
            },
          );
      }
    }

    hanldeToggleAll(saved = false) {
      const { disabled } = this.state;
      if (disabled) {
        return Promise.reject(new Error('Currently Disabled'));
      }
      const { accounts } = this.props;
      const opportunityIds = reduce(accounts, (items, account) => {
        if (account.contactStatus !== 'loaded') {
          each(account.opportunityIds, (id) => {
            items.push(id);
          });
        }
        return items;
      }, []);
      if (opportunityIds.length === 0) {
        return this.props.dispatch(toogleAllAccounts(saved, this.state.tvProductMappings));
      }
      return new Promise((resolve, reject) => {
        this.props.dispatch(massFetchOpportunityContacts(opportunityIds))
          .then(
            () => {
              this.props.dispatch(toogleAllAccounts(saved, this.state.tvProductMappings))
                .then(
                  (r) => {
                    resolve(r);
                  },
                  (e) => {
                    reject(e);
                  },
                );
            },
            (e) => {
              reject(e);
            },
          );
      });
    }

    handleToggleProductMapping(program, tvProductId, tsProductId) {
      this.props.dispatch(nominationToggleProductMapping(program.program_id, program.client_id, tvProductId, tsProductId));
    }

    showEditModal(account, editModalTab = 1) {
      this.setState({ editModalTab });
      this.props.dispatch(editAccount(account));
    }

    showDispositionsDetail(selectedAccountDispositions) {
      this.setState({ showDispositions: true, selectedAccountDispositions });
    }

    hideDispositionsDetail() {
      this.setState({ showDispositions: false });
      delay(() => {
        this.setState({ selectedAccountDispositions: null });
      }, 1000);
    }

    renderError() {
      const { accountErrors, accountHasErrors } = this.props;
      if (!accountHasErrors) {
        return null;
      }
      let message = accountErrors.messge;
      if (accountErrors.data) {
        message = accountErrors.data.message || accountErrors.data;
      }
      return (
        <div className="alert alert-danger">
          <Fa name="exclamation-triangle" /> {message}
        </div>
      );
    }
    renderStats(isSaved = false) {
      const { disabled } = this.state;
      const { programs, indexedProducts, submitParams } = this.props;
      const selectedPrograms = programs[programType];
      const selectedProgram = this.getCurrentProgram();

      const stats = isSaved ? submitParams.savedStats : submitParams.stats;

      const { selectedProductIds } = stats;
      const products = reduce(selectedProductIds, (results, id) => {
        if (indexedProducts[id]) {
          results.push(indexedProducts[id]);
        }
        return results;
      }, []);

      const countAccounts = isSaved ? submitParams.savedParams.length : submitParams.params.length;

      const countBuyers = stats.contactIds.length;
      const invalid = stats.invalidAccounts && stats.invalidAccounts > 0 ? (<div style={{ paddingTop: 5 }} className="pull-right"><Fa className="text-danger" name="exclamation-triangle" /> <NumberDisplay value={stats.invalidAccounts} precision={0} suffix="invalid account" suffixIsUnit /></div>) : null
      const countSelected = stats.selected ? stats.selected.length : 0;

      return (
        <div className={`panel panel-info ${styles.panel}`}>
          <div className="panel-body">
            <div className="clearfix">
              {invalid}
              <div className="pull-left">
                <span>
                  Selected:
                  {' '}
                  <Counter value={countAccounts}><NumberDisplay value={countAccounts} precision={0} suffixIsUnit suffix="account" /></Counter>
                  {' with '}
                  <Counter value={countBuyers}><NumberDisplay value={countBuyers} precision={0} suffixIsUnit suffix="contact" /></Counter>
                </span>
                &nbsp;
                <ProgramDropdown
                  disabled={disabled}
                  showSaveButton={!isSaved}
                  showUnsaveButton={isSaved}
                  disabledSubmit={countAccounts === 0}
                  disabledUnsave={countSelected === 0}
                  programs={selectedPrograms}
                  program={selectedProgram}
                  tvProducts={selectedProgram && selectedProgram.initiatives && selectedProgram.initiatives.products ? selectedProgram.initiatives.products : []}
                  products={products}
                  onProgramChange={this.handleProgramChange}
                  onSubmit={() => { this.hanldeSubmit(isSaved); }}
                  onToggleProductMapping={this.handleToggleProductMapping}
                  requestSave={this.hanldeRequestSave}
                  requestUnsave={this.hanldeRequestUnsave}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    renderSubmitModal() {
      const { submitStatus, submitErrors, submitResults } = this.state;
      let opportunityIds = [];
      let contactIds = [];
      let errorMessage = '';
      if (submitStatus === SUBMIT_STATUS.SUCCESS) {
        each((submitResults || {}).added_sample, (sample) => {
          opportunityIds.push(sample.opportunityId);
          contactIds.push(sample.contactId);
        });
        opportunityIds = uniq(opportunityIds);
        contactIds = uniq(contactIds);
      } else if (submitStatus === SUBMIT_STATUS.FAIL) {
        errorMessage = submitErrors.message || 'Error';
      }

      return (
        <Modal backdrop="static" show={submitStatus !== null} keyboard={false} bsSize="sm">
          <Modal.Body>
            {submitStatus === SUBMIT_STATUS.SUBMITTING &&
              <div className="text-center">
                <p>&nbsp;</p>
                <Spinner />
                <p><em>one moment please...</em></p>
              </div>
            }
            {submitStatus === SUBMIT_STATUS.SUCCESS &&
              <div className="text-center">
                <p>&nbsp;</p>
                <AlertIcon />
                <p>
                  <NumberDisplay value={opportunityIds.length} precision={0} suffix="account" suffixIsUnit />,
                  {' '}
                  <NumberDisplay value={contactIds.length} precision={0} suffix="contact" suffixIsUnit /> has been submitted.
                </p>
              </div>
            }
            {submitStatus === SUBMIT_STATUS.FAIL &&
              <div className="text-center">
                <div className="alert alert-danger">{errorMessage}</div>
              </div>
            }
          </Modal.Body>
          {(submitStatus === SUBMIT_STATUS.SUCCESS || submitStatus === SUBMIT_STATUS.FAIL) &&
            <Modal.Footer>
              <button type="button" className="btn btn-block btn-lg btn-primary" onClick={() => { this.setState({ submitStatus: null }); }}>
                OK
              </button>
            </Modal.Footer>
          }
        </Modal>
      );
    }

    renderTable(program) {
      const {
        masterCheckboxStatus, accounts, selectedAccounts,
        editingAccount,
      } = this.props;
      const { disabled, countSelected } = this.state;
      if (accounts.length === 0) {
        return (
          <div className="alert alert-warning">
            No records found.
          </div>
        );
      }
      return (
        <div>
          <AccountTable
            disabled={disabled}
            tableName={TABLE_NAME}
            accounts={accounts}
            topControls={this.renderStats()}
            selectedAccounts={selectedAccounts}
            countSelected={countSelected}
            masterCheckboxStatus={masterCheckboxStatus.allStatus}
            program={program}
            editingAccount={editingAccount}
            requestShowDispositionsDetail={this.showDispositionsDetail}
            requestEditAccount={this.showEditModal}
            requestshowEditProduct={(o) => { this.showEditModal(o, 3); }}
            requestshowEditContacts={(o) => { this.showEditModal(o, 2); }}
            requestSelectAccount={this.handleRequestSelectAccount}
            requestUnselectAccount={this.handleRequestUnselectAccount}
            requestToggleAll={this.hanldeToggleAll}
          />
        </div>
      );
    }

    renderSavedTable(program) {
      const {
        masterCheckboxStatus, accounts, selectedAccounts,
        editingAccount, savedParamsLoading,
      } = this.props;
      if (savedParamsLoading) {
        return (<ProgressBar />);
      }
      const { disabled, countSelected } = this.state;
      const deals = filter(accounts, { is_saved: true });
      if (deals.length === 0) {
        return (
          <div className="alert alert-warning">No records found.</div>
        );
      }
      return (
        <div>
          <AccountTable
            disabled={disabled}
            tableName={SAVED_TABLE_NAME}
            accounts={deals}
            countSelected={countSelected}
            topControls={this.renderStats(true)}
            selectedAccounts={selectedAccounts}
            masterCheckboxStatus={masterCheckboxStatus.savedStatus}
            program={program}
            editingAccount={editingAccount}
            requestShowDispositionsDetail={this.showDispositionsDetail}
            requestEditAccount={this.showEditModal}
            requestshowEditProduct={(o) => { this.showEditModal(o, 3); }}
            requestshowEditContacts={(o) => { this.showEditModal(o, 2); }}
            requestSelectAccount={this.handleRequestSelectAccount}
            requestUnselectAccount={this.handleRequestUnselectAccount}
            requestToggleAll={() => this.handleRequestToggleAll(true)}
          />
        </div>
      );
    }

    renderModals(program) {
      const {
        accounts, editingContact,
      } = this.props;
      const {
        editModalTab, showDispositions, selectedAccountDispositions,
        showWarning, editedAccounts, editedProgram,
        tvProductMappings,
      } = this.state;
      const realSelectedAccountDispositions = selectedAccountDispositions ? find(accounts, { account_id: selectedAccountDispositions.account_id }) : null;
      const products = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];

      return (
        <div>
          {this.renderSubmitModal()}
          <WarningModal
            isOpen={showWarning}
            opportunities={editedAccounts}
            program={editedProgram}
            onClose={this.handleDismissWarning}
            onConfirm={this.handleConfirmWarning}
          />
          <EditModal
            tab={editModalTab}
            products={products}
            tvProductMappings={tvProductMappings}
            onUpdateAccount={this.handleOnUpdateAccount}
          />
          <EditContactModal
            program={program}
            onContactChange={this.handleContactInfoChange}
            contact={editingContact}
            onClose={() => {
              this.props.dispatch(editAccountEditContact(null));
            }}
          />
          <DispositionModal
            isOpen={showDispositions}
            program={program}
            account={realSelectedAccountDispositions}
            onClose={this.hideDispositionsDetail}
          />
        </div>
      );
    }

    renderUnlinkedTable() {
      const { unlinkedLoading, unlinkedCount } = this.props;
      if (unlinkedLoading) {
        return (<ProgressBar />);
      }
      if (unlinkedCount === 0) {
        return (
          <div className="alert alert-warning">No records found</div>
        );
      }
      return (
        <UnlinkedContactTable
          tableName={UNLINKED_CONTACT_TABLE_NAME}
        />
      );
    }

    renderTabs(program) {
      const {
        totalSaved, subNav,
        savedParamsLoading,
        unlinkedLoading, unlinkedCount,
        accounts,
      } = this.props;
      return (
        <div>
          <ul className="nav nav-tabs">
            {subNav.map((p) => {
              const isSaved = p.type === 'saved';
              const isUnlinked = p.type === 'unlinked';
              let subComp = null;
              if (isSaved) {
                if (savedParamsLoading) {
                  subComp = (<Fa name="spinner" spin />);
                } else if (totalSaved > 0) {
                  subComp = (<span className="badge">{totalSaved}</span>);
                }
              } else if (isUnlinked) {
                if (unlinkedLoading) {
                  subComp = (<Fa name="spinner" spin />);
                } else if (unlinkedCount > 0) {
                  subComp = (<span className="badge">{unlinkedCount}</span>);
                }
              } else if (accounts.length > 0) {
                subComp = (<span className="badge">{accounts.length}</span>);
              }
              return (
                <LinkContainer exact key={p.path} to={p.url}>
                  <NavItem>{p.label} {subComp}</NavItem>
                </LinkContainer>
              );
            })}
          </ul>
          <p />
          <Switch>
            {subNav.map(p => (
              <Route
                exact
                key={p.path}
                path={p.path}
                render={() => {
                  if (p.type === 'table') {
                    return this.renderTable(program);
                  } else if (p.type === 'saved') {
                    return this.renderSavedTable(program);
                  } else if (p.type === 'unlinked') {
                    return this.renderUnlinkedTable();
                  }
                  return null;
                }}
              />
            ))}
          </Switch>
        </div>
      );
    }

    render() {
      const {
        accountLoading, accountLoaded, accountHasErrors, stageMappings,
        programId,
      } = this.props;
      const { disabled, submitStatus } = this.state;
      const wonMapping = find(stageMappings, { label: 'Won' });

      const program = this.getCurrentProgram();
      
      return (
        <div className="container">
          <Helmet title="Customer Experience | Nominations" />
          <RequiredTVProductMappingSetup programType={programType} programId={programId}>
            {(loading, hasSetup, products, alert) => (
              <div>
                <div className="clearfix">
                  <div className="pull-left" style={{ paddingBottom: 10 }}>
                    <NominationNav />
                  </div>
                  {!loading && hasSetup &&
                    <div className="pull-right">
                      <SearchForm
                        onReset={this.hanldeReset}
                        onSearchChange={this.handleFormChange}
                        disabled={disabled}
                        disabledRootLogic
                        loadRecommendedCriteria={false}
                        type="nominations/customer-experience"
                        defaultCriteria={{
                          type: 'groupAND',
                          values: [
                            {
                              tag: 'stage',
                              type: 'include',
                              ...({
                                mappings: wonMapping ? [wonMapping._id] : [],
                              }),
                            },
                            {
                              tag: 'closeDate',
                              type: 'include',
                              values: 'last-90-days',
                            },
                          ],
                        }}
                        systemFilters={['closeDate', 'size', 'dealType', 'product', 'repType', 'repRegion', 'tenure', 'forecast', 'competitor']}
                        pullRight
                      />
                    </div>
                  }
                </div>
                <p />
                {loading && <ProgressBar />}
                {!loading && hasSetup &&
                  <div>
                    {this.renderModals(program)}
                    {accountLoading && !accountLoaded && <ProgressBar />}
                    {!accountLoading && accountLoaded &&
                      <div>
                        <CEStats
                          submitStatus={submitStatus}
                        />
                        {this.renderTabs(program)}
                      </div>
                    }
                    {!accountLoading && accountHasErrors && this.renderError()}
                  </div>
                }
                {!loading && !hasSetup && alert}
              </div>
            )}
          </RequiredTVProductMappingSetup>

          
        </div>
      );
    }
  }

  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      programs: getPrograms(state),
      accounts: getAccounts(state),
      accountLoading: getAccountLoading(state),
      accountLoaded: getAccountLoaded(state),
      accountHasErrors: getAccountHasErrors(state),
      accountErrors: getAccountErrors(state),
      indexedProducts: getIndexedProducts(state),
      selectedAccounts: getSelectedAccounts(state),
      viewableDimensions: getViewableDimensions(state),
      masterCheckboxStatus: getMasterCheckboxStatus(state),
      editingContact: getEditingAccountEditingContact(state),
      editingAccount: getEditingAccount(state),
      submitParams: getSubmitParams(state),
      totalSaved: getTotalSaved(state),
      savedParamsLoading: !getSavedParamsLoaded(state) || getSavedParamsLoading(state),
      unlinkedLoading: getUnlinkedContactLoading(state) || !getUnlinkedContactLoaded(state),
      unlinkedCount: getUnlinkedContacts(state).length,
      tvProductDictionary: getTVProductDictionary(state),
    };
  }

  CustomerExperience.propTypes = {
    programId: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    programs: PropTypes.shape({}).isRequired,
    accountLoading: PropTypes.bool.isRequired,
    accountLoaded: PropTypes.bool.isRequired,
    accountHasErrors: PropTypes.bool,
    accountErrors: PropTypes.shape({}),
    editingAccount: PropTypes.shape({}),
    selectedAccounts: PropTypes.shape({}).isRequired,
    indexedProducts: PropTypes.shape({}).isRequired,
    masterCheckboxStatus: PropTypes.shape({
      allStatus: PropTypes.string.isRequired,
      savedStatus: PropTypes.string.isRequired,
    }).isRequired,
    editingContact: PropTypes.shape({}),
    submitParams: PropTypes.shape({}),
    stageMappings: PropTypes.arrayOf(PropTypes.shape({})),
    totalSaved: PropTypes.number.isRequired,
    savedParamsLoading: PropTypes.bool,
    unlinkedLoading: PropTypes.bool,
    unlinkedCount: PropTypes.number,
    subNav: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tvProductDictionary: PropTypes.shape({}),
  };
  CustomerExperience.defaultProps = {
    stageMappings: [],
    submitParams: {},
    editingContact: {},
    accountErrors: {},
    accountHasErrors: false,
    editingAccount: null,
    savedParamsLoading: true,
    unlinkedLoading: true,
    unlinkedCount: 0,
    tvProductDictionary: {},
  };

  CustomerExperience.contextTypes = {
    router: PropTypes.shape({}),
    addNotification: PropTypes.func.isRequired,
  };

  return withRouter(connect(mapStateToProps)(requiredSetupMappings(CustomerExperience, ['stage'])));
}
